'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
    var AuthWrapper = function (_React$Component) {
        _inherits(AuthWrapper, _React$Component);

        function AuthWrapper() {
            _classCallCheck(this, AuthWrapper);

            return _possibleConstructorReturn(this, (AuthWrapper.__proto__ || Object.getPrototypeOf(AuthWrapper)).apply(this, arguments));
        }

        _createClass(AuthWrapper, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var auth = this.props.auth;

                if (!auth) {
                    this.props.router.push('/signin');
                }
                if (!auth.token) {
                    if (auth.exp > Date.now()) {
                        // 自动登录
                        this.props.dispatch((0, _auth.requestLoginIfNeeded)(auth));
                    } else {
                        this.props.router.push('/signin');
                    }
                }
            }
        }, {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps) {
                var auth = this.props.auth;

                if (!auth) {
                    this.props.router.push('/signin');
                }
                if (!auth.token) {
                    if (auth.exp > Date.now()) {
                        // 自动登录
                        this.props.dispatch((0, _auth.requestLoginIfNeeded)(auth));
                    } else {
                        this.props.router.push('/signin');
                    }
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }]);

        return AuthWrapper;
    }(_react2.default.Component);

    AuthWrapper.propTypes = {
        auth: _react2.default.PropTypes.object.isRequired
    };
    var mapStateToProps = function mapStateToProps(store) {
        var auth = store.auth;
        return {
            auth: auth
        };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(AuthWrapper);
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _auth = require('../actions/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/auth_wrapper.js
// module id = 1566
// module chunks = 0